// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"364":"52c42ba7","4799":"bbecf33b","7182":"46e165db"}[chunkId] + ".chunk.css";
};